(function () {
    'use strict';

    angular
        .module('sod.helper')
        .factory('TextHelper', TextHelper);

    function TextHelper() {
        return {
            addText: addText,
            removeText: removeText
        };

        function addText(original, text, padding) {
            if (hasText(original, text)) {
                return original;
            }

            if (!padding) {
                padding = '';
            }

            return [original, text].join(padding);
        }

        function removeText(original, text) {
            if (!hasText(original, text)) {
                return original;
            }

            const result = original.replace(text, '');
            return result.trim();
        }

        function hasText(original, text) {
            return (original.indexOf(text) >= 0);
        }
    }
})();